// Avalara entity use codes (US) — sent as entityUseCode on tax transactions.
export const EXEMPTION_STATUS_OPTIONS = [
  { value: "A", label: "A - Federal Government" },
  { value: "B", label: "B - State Government" },
  { value: "C", label: "C - Tribal Government" },
  { value: "D", label: "D - Foreign Diplomat" },
  { value: "E", label: "E - Charitable/Exempt Organization" },
  { value: "F", label: "F - Religious Organization" },
  { value: "G", label: "G - Resale" },
  { value: "H", label: "H - Agricultural" },
  { value: "I", label: "I - Industrial Prod/Manufacturers" },
  { value: "J", label: "J - Direct Pay" },
  { value: "K", label: "K - Direct Mail" },
  { value: "L", label: "L - Other/Custom" },
  { value: "M", label: "M - Educational Organization" },
  { value: "N", label: "N - Local Government" },
  { value: "P", label: "P - Commercial Aquaculture" },
  { value: "Q", label: "Q - Commercial Fishery" },
  { value: "R", label: "R - Non-resident" },
  { value: "Taxable", label: "Taxable - Override Exemption" },
];

export const exemptionStatusLabel = (value) =>
  (EXEMPTION_STATUS_OPTIONS.find((o) => o.value === value) || {}).label || "";
